import {cleanFields} from '../../../utilities/helper/cleanFields';
import request from '../../axios';

const PatchMachineryAdvertisement = async (
  payload: IMachineryAdvertisementPayload,
  guid?: string,
) => {
  const newPayload = {
    ad_type: payload.ad_type,
    srs_type: payload.srs_type?.type,
    sub_input: payload.sub_input?.guid,
    title: payload.title,
    description: payload?.description || null,
    ad_price: payload.price_on_call ? null : payload.ad_price,
    price_on_call: payload?.price_on_call || false,
    produce_year:
      payload?.produce_year && payload?.produce_year?.guid !== 'last'
        ? payload?.produce_year?.title
        : null,
    producing_country: payload.producing_country?.guid || null,
    profile_type: 'supplier',
    only_massage_buyer: payload.only_massage_buyer || false,
    attributes: payload.attributes,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    type: 'sequence',
    price_unit: payload?.price_unit?.value || null,
    has_discount: payload?.has_discount ? true : false,
    from_date: payload?.from_date || null,
    to_date: payload?.to_date || null,
    exclude_holydays: payload?.exclude_holydays?.value || null,
    exclude_fridays: payload?.exclude_fridays?.value || null,
    filter: 'advertisement',
    discount_amount: payload?.discount_amount || null,
    images_id:
      payload?.images
        ?.map(item => item)
        .join(',')
        .toString() || null,
    main_image_id: payload?.main_image || null,
    sub_brand_main_image: payload?.sub_brand_main_image,
    ...(payload?.sub_brand && {sub_brand: payload?.sub_brand}),
    ...(payload?.sub_brand_images && {
      sub_brand_images: payload?.sub_brand_images,
    }),
    available_quantity: payload.available_quantity || null,
    min_sell_quantity: payload?.min_sell_quantity || null,
    application_method: payload?.application_method || null,
    combinations: payload?.combinations || null,
  };

  // ✅ specify which fields to check/remove if null
  const cleanedPayload = cleanFields(newPayload, ['attributes']);

  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...cleanedPayload,
  });

  return response.data;
};

export default PatchMachineryAdvertisement;
